export default "__VITE_ASSET__DMlJjerQ__"